module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/holes/panic-door/panicDoor.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/holes/panic-door/panicDoor.png
// module id = 484
// module chunks = 0